import { ISalesDescription } from '../../types/offersData';
import { IApplicationState } from '../../types/redux';

export const getSalesDescription = (state: IApplicationState): ISalesDescription | null => {
  return state.offersData.salesDescription || null;
};
